import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { HeaderAuth } from '../../../layouts/Auth';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import clsx from 'clsx';
import { VuiButton } from '../../../vodea/@vodea-ui/components/VuiButton';
import { useState } from '@hookstate/core/dist';
import { useTranslation } from 'react-i18next';
import { usePassportService } from '../../../vodea/utilities/hooks';
import { Inputs, schema } from './validation';
import {mapHookErrors, showToast} from '../../../vodea/utilities/helpers/global';
import useIsMounted from '../../../vodea/utilities/hooks/useIsMounted';

const Login: React.FC<any> = () => {
  const { t } = useTranslation();
  const isMounted = useIsMounted();
  const loading = useState(false);
  const { login } = usePassportService(true);

  const { register, handleSubmit, errors, setError } = useForm<Inputs>({
    resolver: yupResolver(schema)
  });

  const onSubmit = handleSubmit(data => {
    loading.set(true);

    login(data.email, data.password).catch(e => {
      loading.set(false);
      if (isMounted.current && e?.response?.data?.error) {
        const errors = mapHookErrors(e.response.data.error);
        Object.keys(errors).forEach((key: any) => setError(key, errors[key]));

        showToast(t('errors.credential'), 'error');
      }
    });
  });

  return (
    <>
      <Helmet>
        <title>{t('login.title')}</title>
      </Helmet>
      <HeaderAuth title={t('login.header.0')} subtitle={t('login.header.1')} />

      <form className={'form-wrapper'} onSubmit={onSubmit}>
        <div
          className={clsx({
            'form-group': true,
            error: errors.email
          })}
        >
          <label className={'form-label'}>{t('form.email.label')}</label>
          <input type='text' name='email' className='form-control' ref={register} />
          <label className={'label-help'}>{errors.email?.message}</label>
        </div>
        <div
          className={clsx({
            'form-group mb-4': true,
            error: errors.password
          })}
        >
          <label className={'form-label'}>{t('form.password.label')}</label>
          <input type='password' name='password' className='form-control' ref={register} />
          <label className={'label-help'}>{errors.password?.message}</label>
        </div>

        <div className='d-flex align-items-center justify-content-between mb-4'>
          <div className='form-check'>

          </div>
          <Link to={'/auth/forgot-password'}>{t('login.forgotPassword')}?</Link>
        </div>

        <VuiButton label={t('button.signIn')} loading={loading.get()} forSubmit={true} fullWidth={true} />
      </form>
    </>
  );
};

export default Login;
